module.exports = __webpack_public_path__ + "static/PostGrotesk-Book-483e2d97b1daae60ef4c6e27e18db50b.svg";